<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Bastar Division Rapid Chess Tournament</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span>G.H. Raisoni Memorial Bastar Division Rapid Chess Tournament Concludes Successfully in
                    Jagdalpur</span>
            </h2>
        </div>
        <p><strong>Date:</strong> November 2, 2025</p>
        <p><strong>Venue:</strong> Priyadarshini Indira Stadium, Jagdalpur</p>
        <p>The <strong>G.H. Raisoni Memorial Bastar Division Rapid Chess Tournament</strong> witnessed enthusiastic
            participation from
            players aged 5 to 65 years, showcasing the growing chess culture in the Bastar region.</p>
        <p>Organized under the <strong>Bastar District Chess Association</strong>, recognized by the
            <strong>Chhattisgarh Chess Association</strong>, the
            event was sponsored by the <strong>G.H. Raisoni Sports and Cultural Foundation</strong> and the
            <strong>Kalpana Prakash Welfare
                Foundation.</strong>
        </p>
        <hr>
        <h5 class="primary-purple">Winners</h5>
        <p><strong>Champion: </strong> Aman Raza clinched the overall title, displaying exceptional skill and
            consistency throughout the competition.

            The event featured participation from seven FIDE-rated players, adding prestige and competitiveness to the
            tournament.

        </p>
        <h5 class="primary-purple"> Inauguration Ceremony</h5>
        <ul class="list-style list-style1 mb-3  ">
            <p>The tournament was inaugurated with a ceremonial first move on the chessboard by dignitaries
                including:</p>
            <li><strong>Khem Singh Dewangan,</strong> Commissioner, Jagdalpur Municipal Corporation</li>
            <li><strong>Ratan Lal Jain</strong>, Founder, Gurukul Sanskar School </li>
            <li><strong>Ravindra Thakur</strong>, Eminent Chess Player</li>
            <li><strong>Rajesh Tripathi</strong>, Secretary, District Badminton Association </li>
            <li> <strong>Kailash Chauhan,</strong> Provincial President, Class III Employees Association</li>
            <li><strong>Shailendra Bhadoriya,</strong> Senior Badminton Player</li>
            <li><strong>Pradeep,</strong> Educationist</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Prize Distribution & Closing Ceremony</h5>
        <p>The closing ceremony was graced by <strong>Gyanesh Kumar Mishra,</strong> Superintendent of Post Offices,
            Bastar Division (Chief
            Guest), along with other guests of honor — <strong>Anand Agrawal, Ravindra Verma, Pradeep Sahu
            </strong>(International Softball
            Player), <strong>Ashok Tiwari</strong>, and <strong>Mrs. Laiba Chamadia</strong>, President, Inner Wheel
            Club, Jagdalpur.</p>
        <p> Chief Guest <strong>Gyanesh Kumar Mishra</strong> commended the association’s efforts and promised support
            for organizing a
            future chess event through the Postal Department.</p>
        <h5 class="primary-purple "> Winners List</h5>
        <div class="list-count">
            <ul class="list-style list-style1 mb-3  ">
                <p> <strong>Open Category</strong> </p>
                <li> Aman Raza</li>
                <li> Jai Singh Kashyap</li>
                <li> Sahil Sagar</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p> <strong>Under-17 (Girls) </strong></p>
                <li> Nishita Dewangan</li>
                <li> Purnima Sagar</li>
                <li> Arshiya Khan</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p> <strong>Under-17 (Boys) </strong></p>
                <li> Mayank Srivastava</li>
                <li>Yasir Pasha </li>
                <li> Divyaraj Jha</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-13 (Girls)</strong></p>
                <li>Alankrita Moharana</li>
                <li>Sakshi Kumari</li>
                <li>Avni Jaan</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-13 (Boys)</strong></p>
                <li>Swastik Sagar</li>
                <li> Suraj Verma</li>
                <li> Amartya Sarathi</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-9 (Boys)</strong></p>
                <li>Zidan Chamadia</li>
                <li> Vedant Shukla</li>
                <li> K. Bhuvan Abhinay</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-9 (Girls)</strong></p>
                <li> Anushka Kumari</li>
                <li> Dhanshree Danda</li>
                <li> Ananya Srivastava</li>
            </ul>
        </div>
        <hr>
        <h5 class="primary-purple "> Technical Officials</h5>
        <ul class="list-style list-style1 mb-3  ">
            <li>Chief Arbiter: Tarun Sarathi</li>
            <li> Deputy Chief Arbiter: Ayaz Chamadia</li>
            <li> Arbiters: Abhinav Jena, Rajesh Jena, Purnima Saroj, and Jayashree Shende</li>
        </ul>
        <hr>
        <h5 class="primary-purple "> Organizing Committee </h5>
        <p>The event was successfully conducted under the leadership of <strong>Hitesh Tiwari</strong>, Secretary,
            Bastar District
            Chess Association, with valuable support from <strong>B.S. Dhruv, Sangeeta Tiwari, Sukirti Tiwari, Manju
                Sarathi, Ishwari Dhruv, Suchismita Jena, Lokesh Pandey, Minesh Panigrahi,</strong> and
            <strong>Abhishek Jena</strong>.
        </p>
        <p><strong>Shashank Sridhar </strong>, President of the Bastar District Chess Association and Joint
            Secretary of the
            Chhattisgarh State Chess Association, expressed gratitude to the <strong>Raisoni Foundation</strong> and
            <strong>Kalpana Prakash
                Welfare Foundation</strong> for their continued contributions to education and chess development
            across India.
        </p>
        <p>He highlighted that, under the guidance of <strong>Mr. Vinod Rathi</strong>, General Secretary of the
            Chhattisgarh Chess
            Association, a strong chess culture has flourished even in remote areas like Bastar.
            This event was particularly notable as the <strong>first Bastar Divisional Chess Tournament conducted
                entirely
                by local arbiters</strong> — a significant milestone for the region.</p>
        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-4.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-5.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-5.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-5.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-6.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-6.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-6.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</section>
